// extracted by mini-css-extract-plugin
module.exports = {"groupWrapper":"ScommesseGroupWrapper_groupWrapper__sGRqS","fullWidth":"ScommesseGroupWrapper_fullWidth__UkKP0"};